import React from "react";
import { ItineraryItem } from "@/types/trip";
import { Card, CardContent } from "@/components/ui/card";
import { formatImageUrl } from "@/lib/general";

interface TravelDayProps {
  activity: ItineraryItem;
}

const TravelDay: React.FC<TravelDayProps> = ({ activity }) => {
  return (
    <div className="activity-item w-full">
      <Card className="my-3 rounded-2xl border-neutral-200/75 hover:shadow transition-all duration-300 ease-in-out">
        <CardContent className="p-2">
          <div className="flex items-start space-x-4">
            <div className="h-[8rem] w-[10rem] rounded-l-xl rounded-r-md overflow-hidden flex-shrink-0 relative">
              <img
                src={formatImageUrl(
                  "https://pub-b8cc892604024ad0a45e17686b510e8f.r2.dev/travelday3.png",
                  "high"
                )}
                alt="Travel"
                className="w-full h-full object-cover items-center justify-center"
              />
            </div>
            <div className="flex-grow flex flex-col min-h-[8rem]">
              <div className="w-full">
                <div className="flex items-center space-x-2">
                  <h2 className="text-base font-medium text-neutral-800">
                    {activity.name || "Travel Day"}
                  </h2>
                </div>
                <p className="mt-2 text-xs font-light text-neutral-700 w-[95%]">
                  {activity.metadata.description ||
                    "A day dedicated to traveling between locations."}
                </p>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default TravelDay;
